webpackJsonp([39],{

/***/ 1530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemGeneralAlarms_vue__ = __webpack_require__(1887);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31433063_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemGeneralAlarms_vue__ = __webpack_require__(2252);
function injectStyle (ssrContext) {
  __webpack_require__(2250)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemGeneralAlarms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31433063_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemGeneralAlarms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        systemName: {
            required: false,
            type: String
        },
        systemId: {
            required: false,
            type: String
        }
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    components: {},
    data: function data() {
        return {
            data: [],
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [{ text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "CheckBox"
            },
            customAttributes: { class: "customcss" },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.dispatch('set_loading', true);
                                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_71" /* getSystemGeneralAlarms */])(_this.systemId).then(function (response) {
                                    _this.data = response.data;
                                    _this.data.forEach(function (el) {
                                        var minDate = new Date("2001-01-01");
                                        if (new Date(el.endDate) < minDate) {
                                            el.endDateString = '-';
                                        } else {
                                            el.endDateString = el.endDate.toDateTime();
                                        }

                                        if (new Date(el.dismissDate) < minDate) {
                                            el.dismissDateString = '-';
                                        } else {
                                            el.dismissDateString = el.dismissDate.toDateTime();
                                        }
                                    });

                                    _this.data.sort(function (b, a) {
                                        return new Date(a.createDate) - new Date(b.createDate);
                                    });
                                    _this.$store.dispatch('set_loading', false);
                                });

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        }
    },
    mounted: function mounted() {
        this.getData();
    }
});

/***/ }),

/***/ 2250:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2251);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("5847ebe7", content, true, {});

/***/ }),

/***/ 2251:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SystemGeneralAlarms.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('div',{staticClass:"max-grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"type":"dateTime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"alarmName","headerText":_vm.$t('AlarmName'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"description","headerText":_vm.$t('Description'),"width":"500px","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"endDateString","headerText":_vm.$t('EndDate'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"dismissDateString","headerText":_vm.$t('DismissDate'),"textAlign":"Left","customAttributes":_vm.customAttributes}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/39.58bc6bbb02088c766e14.js